module.exports = __webpack_public_path__ + "media/assets/icons/chevron-small-left-2bd41953edff0c3dafae5c78e1d8f2ab.svg";